document.addEventListener('DOMContentLoaded', function () {
  // Fade-up scroll reveal
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) entry.target.classList.add('in');
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.fade-up').forEach(function (el) { observer.observe(el); });

  // Quantity selectors (works for any .qty-box on the page)
  document.querySelectorAll('.qty-box').forEach(function (box) {
    var input = box.querySelector('input, span');
    var buttons = box.querySelectorAll('button');
    if (buttons.length < 2 || !input) return;
    buttons[0].addEventListener('click', function () {
      var val = parseInt(input.value || input.textContent, 10) || 1;
      if (val > 1) val--;
      if (input.tagName === 'INPUT') input.value = val; else input.textContent = val;
    });
    buttons[1].addEventListener('click', function () {
      var val = parseInt(input.value || input.textContent, 10) || 1;
      val++;
      if (input.tagName === 'INPUT') input.value = val; else input.textContent = val;
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('.thumb-row img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('.product-media .main-image img');
      if (mainImg && thumb.dataset.full) {
        mainImg.src = thumb.dataset.full;
      }
      document.querySelectorAll('.thumb-row img').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Mobile sticky bar quantity sync + add to cart trigger main form
  var mobileBtn = document.querySelector('.mobile-bar [data-mobile-add]');
  if (mobileBtn) {
    mobileBtn.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }
});
